import { useEffect, useId, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaBars, FaXmark } from "react-icons/fa6";
import "./MontacargasNavbar.css";

// Navbar azul de amcmontacargas-L8.8 (search.blade.php / index.blade.php):
// título a la izquierda y botón hamburguesa que despliega las acciones
// (Cerrar sesión, Regresar...). Se cierra al tocar fuera, con Escape, al
// cambiar de ruta o al elegir una acción.
function MontacargasNavbar({ title, children }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const menuId = useId();
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("pointerdown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  // Cualquier botón/enlace del menú lo cierra al usarse.
  const handleMenuClick = (event) => {
    if (event.target.closest("button, a")) setOpen(false);
  };

  return (
    <header className="mc-navbar" ref={containerRef}>
      <div className="mc-navbar__bar">
        <h1 className="mc-navbar__title">{title}</h1>
        <button
          type="button"
          className="mc-navbar__toggle"
          aria-controls={menuId}
          aria-expanded={open}
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <FaXmark aria-hidden="true" /> : <FaBars aria-hidden="true" />}
        </button>
      </div>

      <div
        id={menuId}
        className={`mc-navbar__menu${open ? " is-open" : ""}`}
        aria-hidden={!open}
        inert={!open}
      >
        <div className="mc-navbar__menu-inner">
          <nav className="mc-navbar__items" onClick={handleMenuClick}>
            {children}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default MontacargasNavbar;
